import create from "zustand";
import { MeModelInterface } from "../interfaces/me-model.interface";
import { GetMe, Login } from "../providers/auth.provider";

interface AuthState {
  message: string;
  loading: boolean;
  isLoggedIn: boolean;
  meModel: MeModelInterface;
  login: (username: string, password: string) => void;
  checkAuth: () => void;
  logout: () => void;
  getMe: () => void;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  message: "",
  loading: false,
  isLoggedIn: false,
  meModel: undefined,
  checkAuth: () => {
    const token = localStorage.getItem("token");
    if (token) {
      set({ isLoggedIn: true });
      get().getMe();
    } else {
      set({ isLoggedIn: false });
    }
  },
  login: async (username: string, password: string) => {
    set({ loading: true });
    const response = await Login(username, password);

    if (response.status) {
      localStorage.setItem("token", response.data.accessToken);
      get().getMe();
      set({ isLoggedIn: true });
    }

    set({
      message: response.message,
      loading: false,
    });
  },
  logout: () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("userId");
    set({ isLoggedIn: false, meModel: undefined });
  },
  getMe: async () => {
    const response = await GetMe();
    if (response.status) {
      localStorage.setItem("role", response.data.role.slug);
      localStorage.setItem("userId", response.data.id);
      set({ meModel: response });
    } else {
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      localStorage.removeItem("userId");
      set({ isLoggedIn: false, meModel: undefined });
    }
  },
}));
